"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var Components_1 = require("../../utils/Components");
var propTypeUtils_1 = require("../../utils/propTypeUtils");
var FormRow_1 = require("../FormRow");
var propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.element]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    children: propTypeUtils_1.allowedChildren('Radio')
};
/**
 * A `RadioGroupRow` component is used to uniquely select a value from a list
 * of values.
 *
 * <div class="box box--ux">
 *   <p>
 *     From an UX point of view, only up to a maximum of three selection options
 *     should be offered. If there are more than three choices, the <a
 *     href="#!/SelectRow">SelectRow</a>-component should be used instead.
 *   </p>
 * </div>
 */
var RadioGroupRow = /** @class */ (function (_super) {
    __extends(RadioGroupRow, _super);
    function RadioGroupRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioGroupRow.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, description = _a.description, error = _a.error, label = _a.label, tooltip = _a.tooltip, name = _a.name, disabled = _a.disabled, value = _a.value, defaultValue = _a.defaultValue, other = __rest(_a, ["children", "className", "description", "error", "label", "tooltip", "name", "disabled", "value", "defaultValue"]);
        // only count element children, ignore unredered nodes
        var numberOfChildElements = Components_1.getChildElements(children).length;
        var alignment = numberOfChildElements < 3 ? 'horizontal' : 'vertical';
        var hasError = Boolean(error);
        var isControlled = typeof value !== 'undefined';
        return (React.createElement(FormRow_1.FormRow, __assign({ alignment: alignment, label: label, description: description, tooltip: tooltip, error: typeof error === 'boolean' ? undefined : error, className: classNames('ee_radio-group-row', className) }, other), React.Children.map(React.Children.toArray(children), function (child) {
            if (React.isValidElement(child))
                return React.cloneElement(child, {
                    name: name,
                    disabled: disabled !== undefined ? disabled : child.props.disabled,
                    /**
                       * If the component is uncontrolled and the defaultValue prop has been set,
                       * apply to the child with the matching value the defaultChecked prop,
                       * otherwise leave it undefined because the child takes care of it itself
                       */
                    defaultChecked: !isControlled && defaultValue !== undefined
                        ? child.props.value === defaultValue
                        : child.props.defaultChecked,
                    checked: isControlled ? value === child.props.value : child.props.checked,
                    error: hasError
                });
        })));
    };
    RadioGroupRow.propTypes = propTypes;
    RadioGroupRow.defaultProps = {
        name: undefined,
        defaultValue: undefined,
        value: undefined,
        label: undefined,
        tooltip: undefined,
        description: undefined,
        error: false,
        disabled: undefined
    };
    return RadioGroupRow;
}(react_1.Component));
exports.RadioGroupRow = RadioGroupRow;
exports.default = RadioGroupRow;
//# sourceMappingURL=RadioGroupRow.js.map